export default "__VITE_ASSET__BEVEuiU0__"